import { MonitoringSource } from "@services/devices/types";

export const monitoringSourceLabelMap = {
  [MonitoringSource.CommProxy]: "Direct",
  [MonitoringSource._3rdPartyManagement]: "Aggregator",
  [MonitoringSource.RoomController]: "Controller",
  [MonitoringSource.AVISPLMonitoringAgent]: "DMCA",
};
